<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="11">
        <strong>{{name}}</strong>
        <p class="text-danger">ファイアウォールモードがOn(ブロック)の場合のみ、ブロックが可能です。</p>
        <hr>
        <p>1行に1つ入力します。 {{name}}.</p>
        <p v-if="name == 'path'">例えば、保護が必要な管理者パスなどを入力します。</p>
        <p v-if="name == 'params'">get sql-injection などの攻撃が追加される可能性があります。</p>

        <p>* 例</p>
        <pre v-html="ex"></pre>
        <!-- ex : /admin,/admin,/admin -->
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-textarea @update="update($event, name)" id="ph_content" v-model="model" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="パスブロック"  class="modal-info" v-model="explain_path" ok-only no-close-on-backdrop ok-variant="success" header-bg-variant="warning">
      <p>特定のパスからのページをブロックする。</p>
      <p>例 ) http://f1security.co.kr/manager/index.html</p>
      <p>上記のようなパス/managerをブロックすると、index.htmlのページがブロックされます。</p>
    </b-modal>
    <b-modal title="パラメータブロック"  class="modal-info" v-model="explain_params" ok-only no-close-on-backdrop ok-variant="success" header-bg-variant="warning">
      <p>特定のパラメータをブロックします。</p>
      <p>例 ) kyword=password</p>
      <p>上記のように見えるパスワードのパラメータをブロックすると、パスワードという単語のパラメータを検出/ブロックすることになります。</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
